// EN
export const calendarsChatbotHc = {
  monthlyCalendar: {
    pricesTitle: "Dynamic pricing",
    prices: "Prices",
    noPropertiesAvailable: "No properties available",
    noPropertiesFound: "No properties found",
    minStayShort: "min. {n}n",
    available: "Available",
    closed: "Closed",
    loading: "Loading…",
    showMoreMonths: "Show more months",
    from: "From",
    to: "To",
    nightsLabelOne: "{n} night",
    nightsLabelMany: "{n} nights",
    whatToDo: "What would you like to do?",
    close: "Close",
    open: "Open",
    price: "Price",
    minStay: "Min. stay",
    closeReasonPlaceholder: "Reason for closing (optional)",
    openHint: "The selected dates will be reopened (the block is removed).",
    nightsWord: "nights",
    clearSelection: "Clear selection",
    past: "Past",
    guestOne: "guest",
    guestMany: "guests",
    perNight: "/ night",
    noName: "No name",
    channelDirect: "Direct",
    ownerBlockComment: "Block by the owner",
    prepTime: "Preparation time",
    sameDayCutoff: "Same-day cutoff",
    linkedClosed: "Whole apartment",
    linkedClosedInfo: "Closed by the whole-apartment rule ({motivo}). It will reopen on its own if that booking is cancelled or its dates change.",
    alsoLinked: "also closed by the whole-apartment rule ({motivo})",
    applyClose: "Close dates",
    applyOpen: "Open dates",
    applyPrice: "Save price",
    applyMinStay: "Save minimum stay",
    apply: "Apply",
    processing: "Processing…",
    closingDates: "Closing dates…",
    openingDates: "Opening dates…",
    priceModeLabel: "Price mode",
    priceModeFixed: "Fixed",
    priceModePercent: "%",
    priceModeAmount: "Amount",
    percentPlaceholder: "e.g. 20",
    amountPlaceholder: "e.g. 10",
    percentHint: "Each night is recalculated from its own price. Use − to lower it.",
    amountHint: "Added to what each night already costs. Use − to lower it.",
    invalidPrice: "Enter a valid price.",
    changingPrice: "Changing price per night…",
    priceUpdated: "Price updated successfully.",
    priceUpdateError: "The price could not be updated.",
    minStayMin: "The minimum stay must be at least 1 night.",
    changingMinStay: "Changing minimum stay…",
    minStayUpdated: "Minimum stay updated successfully.",
    minStayUpdateError: "The minimum stay could not be updated.",
    unknownError: "Unknown error",
  },
  calendar: {
    channelDirect: "Direct",
    searchMin2: "Type at least 2 characters to search",
    searchNoResults: "No bookings were found for that search",
    searchError: "Error while searching for bookings",
    processing: "Processing…",
    ownerBlockComment: "Block by the owner",
    cutoffTip: "Same-day sales cutoff at {time}",
    nightsLabelOne: "{n} night",
    nightsLabelMany: "{n} nights",
    turnoverBefore: "Preparation time: block {nights} before each check-in",
    turnoverAfter: "Preparation time: block {nights} from each check-out",
    turnoverBoth: "Preparation time: block {nights} before check-in and from check-out",
    selectAtLeastOneProperty: "Select at least one property.",
    selectAtLeastOneDate: "Select at least one effective date to apply the changes.",
    preparingOps: "Preparing {total} operations...",
    applyingOps: "Applying {index} of {total}: {name}",
    unknownError: "Unknown error",
    couldNotSaveChanges: "The changes could not be saved.",
    bulkApplyError: "The bulk changes could not be applied. {message}",
    opsApplied: "{success} of {total} operations were applied.",
    opsSkipped: "{skipped} dates with confirmed bookings were skipped.",
    opsFailed: "{failed} operations failed.",
    bulkApplied: "Bulk edit applied to {count} properties.",
    couldNotOpenDate: "The date could not be opened",
    datesOpened: "Dates opened",
    closeUpdated: "Block updated",
    todayLabel: "Today",
    closed: "Closed",
    linkedClosed: "Whole apartment",
    linkedClosedInfo: "Closed by the whole-apartment rule ({motivo}). It will reopen on its own if that booking is cancelled or its dates change.",
    alsoLinked: "also closed by the whole-apartment rule ({motivo})",
    closingDates: "Closing dates…",
    couldNotCloseDates: "The dates could not be closed",
    clearFiltersTitle: "Clear filters",
    noPropertiesAvailable: "No properties available",
    noPropertiesFound: "No properties found",
    dynamicPricesTitle: "Dynamic pricing",
    prices: "Prices",
    viewWide: "Wide view",
    viewCompact: "Compact view",
    viewNormal: "Normal view",
    viewFull: "View full",
    searchBookingTitle: "Search booking",
    searchBookingPlaceholder: "Search booking…",
    search: "Search",
    resultsSelectOne: "{count} results — select one:",
    bulkEdit: "Bulk edit",
    goToTodayTitle: "Go to today",
    showHeader: "Show header",
    configArrivalDeparture: "Configure arrival and departure rules",
    notAvailable: "Not available",
    extension: "Extension",
    lateCheckoutUntil: "Late checkout until {time}",
    aiRequests: "AI reception",
    guestComments: "Guest comments",
    internalNotes: "Internal notes",
    extrasTitle: "Purchased extras",
    extrasPending: "Awaiting confirmation",
    reqArrivalTitle: "Arrival time",
    reqAt: "at {time}",
    reqUntil: "until {time}",
    reqNights: "Extra nights: {n}",
    reqPending: "Pending",
    reqConfirmed: "Confirmed",
    reqPaid: "Paid",
    reqOffered: "Offered",
    reqPrioritised: "Prioritised",
    pendingAmount: "Pending:",
    noticesColumn: "Notices",
    callsTitle: "Calls",
    callsCount: "Calls: {n}",
    extensionPaid: "Extension paid",
    listCheckin: "Check-in",
    listCheckout: "Check-out",
    priceOriginal: "Original booking",
    priceExtension: "Extension",
    priceTotal: "Total",
    paymentInProcess: "Payment in progress",
    overbooking: "Overbooking",
    noAccommodationsFound: `No properties were found matching "{term}".`,
    past: "Past",
    paymentInProcessLower: "payment in progress",
    pendingApproval: "pending approval",
    pendingApprovalTitle: "Pending approval",
    guestOne: "guest",
    guestMany: "guests",
    perNight: "/ night",
  },
  tableFilters: {
    filterByDate: "Filter by date from - to",
    filterByCountry: "Filter by country",
    all: "All",
    countrySpain: "Spain",
    countryColombia: "Colombia",
    countryBrazil: "Brazil",
    filterByState: "Filter by status",
    allStates: "All statuses",
    stateDemo: "Demo version",
    stateSubscribed: "Subscribed",
    stateNotSubscribed: "Not subscribed",
    searchRecords: "Search the records",
  },
  chatbotPageIndex: {
    aiAgentBadge: "AI Agent",
    planFeatureHint: "Feature available with a paid plan.",
    otaAgentTitle: "AI Agent for OTAs",
    otaAgentHint: "Enable it so the agent automatically replies to messages from Booking, Airbnb and other OTAs.",
    otaRequiresWhatsapp: "Requires the WhatsApp AI Agent to be active.",
    guardNotice: "With the AI Agent disabled, the chat also switches to <strong>manual reply</strong> automatically. The per-conversation switches will stay locked until you reactivate it.",
    configureBasic: "Configure basic AI agent",
    configureAdvanced: "Configure advanced AI agent",
    comingSoon: "Coming soon",
    detailFallback: "Detail",
    errorLoadListingConfig: "The listing configuration could not be loaded",
    errorSaveChange: "Error saving the change",
    otaAgentActivated: "AI Agent for OTAs activated",
    otaAgentDeactivated: "AI Agent for OTAs deactivated",
  },
  chatbotIndex: {
    accommodationFallback: "Property",
    defaultHandoffSupportLine: "\nIf you need quick assistance, contact us at {phone} 📞",
    defaultHandoffMessage: "Hello 😊 Right now I don't have that information, but a member of our team will assist you soon 🙌{suffix}\nWe're here for you throughout your stay! 🏡✨",
    silentModeMessage: "No automatic reply will be sent to the guest. The system will keep notifying the operator so they can continue the conversation.",
    statusNoGuestReply: "No reply to the guest",
    statusUsingCustom: "Using custom message",
    statusUsingDefault: "Using default message",
    helperSilent: "The guest will not receive an automatic reply when the AI Agent does not know what to answer, but the operator will receive the notification to take over the conversation.",
    helperCustom: "The system will automatically translate this custom message into the guest's language.",
    helperHasCustom: "You have a saved custom message, but right now the system will keep using the default message.",
    helperDefault: "If you create a master message, you can enable it here and the system will automatically translate it into the guest's language.",
    sourceSilent: "Silent",
    sourceCustom: "Custom",
    sourceDefault: "Default",
    defaultBotName: "My Virtual Assistant",
    errorLoadBotName: "The assistant's name could not be loaded.",
    errorLoadHandoff: "The handoff message could not be loaded.",
    botNameUpdated: "Assistant name updated.",
    errorSaveBotName: "The assistant's name could not be saved.",
    masterMessageUpdated: "Master message updated.",
    errorSaveMaster: "The master message could not be saved.",
    warnCreateCustomFirst: "First create a custom message before enabling it.",
    modeCustomActivated: "The custom message will now be used.",
    modeSilentActivated: "The bot will stay silent when it does not know how to answer, but the operator will still be notified.",
    modeDefaultActivated: "The default message will now be used.",
    errorUpdateActiveMessage: "The active message could not be updated.",
    warnWriteQuestion: "Write a question before saving.",
    questionCreated: "Question created successfully.",
    errorAddQuestion: "The question could not be added.",
    botNamePlaceholder: "Assistant name",
    handoffRowTitle: "Message when the agent doesn't know how to answer",
    customize: "Customize",
    expandAria: "Expand",
    handoffSubtitle: "This text will be sent when the AI Agent cannot find the answer in the facts, the memory or the FAQs.",
    modeDefaultTitle: "Default message",
    modeDefaultDesc: "Use the system's standard message with the support phone number.",
    modeCustomTitle: "Custom message",
    modeCustomDescActive: "Enable the custom text you saved in the modal.",
    modeCustomDescEmpty: "You haven't created a custom message yet.",
    modeSilentTitle: "Do not reply to the guest",
    modeSilentDesc: "The guest does not receive an automatic message, but the operator will be notified to continue the conversation.",
    loadingMessage: "Loading message...",
    masterMessage: "Master message",
    newQuestionTitle: "New question",
    newQuestionSubtitle: "Create a new frequently asked question so the AI Agent can answer it more accurately.",
    guestQuestionLabel: "Guest question",
    questionPlaceholder: "e.g. What time is check-in?",
    questionHelp: "Tip: write the question the way a real guest would.",
    cancel: "Cancel",
    saveQuestion: "Save question",
    handoffKicker: "Handoff reply",
    handoffModalTitle: "Customize master message",
    handoffModalSubtitle: "Write a single message in Spanish. The system will translate it automatically and reply according to the language the guest is speaking.",
    masterToolbarInfo: "You can use emojis and a friendly tone, just like in your other automatic messages.",
    emojiSearchPlaceholder: "Search emoji...",
    masterTextareaPlaceholder: "Write the master message here. You can use emojis and a warm tone for the guest.",
    masterHint: "Recommendation: write the message in Spanish with the exact tone you want to convey. The system will adapt it automatically to the guest's language.",
    viewDefaultMessage: "View default message",
    saveMessage: "Save message",
    newButton: "New",
    emojiButton: "Emoji",
  },
  messageAccountDemo: {
    usingDemo: "You are using the demo version",
    ofThePlatform: "of the platform",
    trialHave: "You still have",
    trialDaysToEnjoy: "days to enjoy all the features!",
    trialSubscribeNow: "Subscribe now and keep managing your properties without interruptions.",
    subscribeNowLabel: "Subscribe now",
  },
};
